import React from 'react';
import styles from '../BranchDrawer.module.css';
import Ico from '../../common/Ico';
import Pill from '../../common/Pill';
import TierPill from '../../common/TierPill';
import { statusLabel } from '../statusConfig';
import { avatarColor, clusterInitial, flagFor } from '../../../helpers/clusters';
import { ICO_EXTERNAL, ICO_LAYERS, ICO_ROCKET, ICO_SEARCH } from './constants';

export default function RolloutCard({ build, clusterMap, clusterQ, onClusterQChange }) {
  if (!build.deployments?.length) return null;

  const deployStatus = build.deployments;
  const rolloutUrl   = build.rollout_url || null;
  const base         = rolloutUrl?.match(/^(https?:\/\/[^/]+)/)?.[1] || null;
  const depDeployed  = deployStatus.filter(c => c.status === 'completed').length;
  const depTotal     = deployStatus.length;

  const enriched = deployStatus.map(d => ({
    ...(clusterMap[d.cluster_id] || {}),
    ...d,
    _name: clusterMap[d.cluster_id]?.name || d.cluster_id,
  }));
  const visible = clusterQ
    ? enriched.filter(c => c._name.toLowerCase().includes(clusterQ.toLowerCase()))
    : enriched;

  const rolloutVersion  = build.build_tag || (rolloutUrl ? rolloutUrl.split('/rollouts/')[1] || null : null);
  const rolloutStatus   = deployStatus.every(c => c.status === 'completed') ? 'completed'
    : deployStatus.some(c => c.status === 'errored') ? 'errored' : 'running';
  const rolloutPct      = depTotal > 0 ? Math.round((depDeployed / depTotal) * 100) : 0;
  const rolloutFillColor = rolloutStatus === 'completed' ? 'var(--success-500)' : 'var(--brand-primary)';

  return (
    <div className={styles.povCard}>
      <div className={styles.povCardHead}>
        <span className={styles.povIconTile}>
          <Ico d={ICO_ROCKET} size={19} strokeWidth={1.7} />
        </span>
        <div className={styles.povTitleCol}>
          <div className={styles.povTitleRow}>
            <span className={styles.povTitle}>Rollout</span>
            {rolloutVersion && <span className={styles.povVersionBadge}>{rolloutVersion}</span>}
            <span className={styles.povManaged}>
              <Ico d={ICO_LAYERS} size={11} strokeWidth={1.8} />
              Managed in Hypervisor
            </span>
          </div>
          <div className={styles.povProgressRow}>
            <div className={styles.povProgressTrack}>
              <div className={styles.povProgressFill} style={{ width: `${rolloutPct}%`, background: rolloutFillColor }} />
            </div>
            <span className={styles.povCount}>
              <strong>{depDeployed}</strong> of {depTotal} clusters deployed
            </span>
          </div>
        </div>
        <div className={styles.povRightCol}>
          <Pill status={rolloutStatus} dot={false}>{statusLabel(rolloutStatus)}</Pill>
          {rolloutUrl && (
            <a href={rolloutUrl} target="_blank" rel="noreferrer" className={styles.povViewBtn}>
              Open rollout <Ico d={ICO_EXTERNAL} size={12} />
            </a>
          )}
        </div>
      </div>
      <div className={styles.clusterList}>
        <div className={styles.clusterSearchRow}>
          <div className={styles.clusterSearchWrap}>
            <Ico d={ICO_SEARCH} size={13} style={{ color: 'var(--fg-muted)', flexShrink: 0 }} />
            <input
              className={styles.clusterSearchInput}
              value={clusterQ}
              onChange={e => onClusterQChange(e.target.value)}
              placeholder="Search clusters…"
            />
          </div>
          <span className={styles.clusterCount}>{visible.length} of {depTotal} clusters</span>
        </div>
        <div className={styles.clusterCards}>
          {visible.map(c => {
            const hyperUrl = c.op_url || (base ? `${base}/cluster/${c.cluster_id}` : null);
            return (
              <a
                key={c.cluster_id}
                href={hyperUrl || '#'}
                target="_blank"
                rel="noreferrer"
                className={styles.clusterCard}
              >
                <span className={styles.clusterAvatar} style={{ background: avatarColor(c._name) }}>
                  {clusterInitial(c._name)}
                </span>
                <span className={styles.clusterInfo}>
                  <span className={styles.clusterNameRow}>
                    <span className={styles.clusterName}>{c._name}</span>
                    {c.tier && <TierPill tier={c.tier} />}
                  </span>
                  {c.region && (
                    <span className={styles.clusterRegion}>{flagFor(c.region)} {c.region}</span>
                  )}
                </span>
                <Pill status={c.status} dot>{statusLabel(c.status)}</Pill>
                <Ico d={ICO_EXTERNAL} size={13} style={{ color: 'var(--fg-link)', flexShrink: 0 }} />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
